



























































import { defineComponent } from "@vue/composition-api";
import draggable from "vuedraggable";
import useVaultView from "@/hooks/useVaultView";
import { getPostAllowedFileTypes, isAttachmentFile } from "@/lib/fileHelpers";
import { AttachmentFile, PostFileData } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";
import PostFileList from "@/components/PostFileList";
import VaultModal from "@/components/VaultModal";
import { AddingFilesOptions, DraggableEmitOptions } from "../../types";
import EditPostDropZone from "../EditPostDropZone";
import PostFileThumbnail from "../PostFileThumbnail";
import PreviewSetButton from "../PreviewSetButton";

export default defineComponent({
  name: "PostFilesArea",
  components: {
    BaseIcon,
    BaseInputFile,
    VaultModal,
    BaseButton,
    PostFileThumbnail,
    EditPostDropZone,
    PostFileList,
    PreviewSetButton,
    draggable,
  },
  props: {
    fileList: { type: Array as () => PostFileData[], required: true },
    showPublicButton: { type: Boolean, default: false },
    newFilePublicAccess: { type: Boolean, default: false },
  },
  setup() {
    const { isVaultAvailable, showPrivateVault: showVault, showVaultOrNative } = useVaultView();

    return { isVaultAvailable, showVault, showVaultOrNative };
  },
  data() {
    return {
      isDragAndMoveActive: false,
    };
  },
  computed: {
    allowedFileTypes(): string[] {
      return getPostAllowedFileTypes();
    },
    draggableOptions(): Record<string, string | boolean | number> {
      return {
        delay: 200,
        supportPointer: false,
        disabled: this.fileList.length < 2,
        dragClass: "post-files-area__dragging",
        chosenClass: "post-files-area__ghost",
        ghostClass: "post-files-area__ghost",
      };
    },
  },
  methods: {
    onUpdateDraggable({ newDraggableIndex, oldDraggableIndex }: DraggableEmitOptions): void {
      this.$emit("draggable:update", { newDraggableIndex, oldDraggableIndex });
      this.isDragAndMoveActive = false;
    },

    onAddFiles(files: (AttachmentFile | File)[], options: AddingFilesOptions): void {
      if (files.every(isAttachmentFile)) {
        this.$emit("addFilesFromVault", files, options);
      } else {
        this.$emit("addFiles", files, options);
      }
    },
  },
});
